import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnonymousSessionService {

  private selectedLanguage = new Subject<string>();

  constructor() { }

  setAnonymousSessionLanguage(lang: string){
    this.selectedLanguage.next(lang);
    this.selectedLanguage.complete();
  }

  getAnonymousSessionLanguage(): Observable<string> {
    return this.selectedLanguage.asObservable();
  }
}
